/* __next_internal_client_entry_do_not_use__ AppModalType,AppDownload auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { Button } from "@faire/web--source/slate/Button";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { trackRetailerMobileFooterDesktopappModalandroidDismissClick } from "@faire/web-api--source/events/retailerMobile/click/footerDesktopAppModalAndroidDismiss";
import { trackRetailerMobileFooterDesktopappModaliosDismissClick } from "@faire/web-api--source/events/retailerMobile/click/footerDesktopAppModalIosDismiss";
import { trackRetailerMobileFooterMwebDesktopappStoreBadgeClick } from "@faire/web-api--source/events/retailerMobile/click/footerMwebDesktopAppStoreBadge";
import { trackRetailerMobileFooterMwebDesktopgooglePlayBadgeClick } from "@faire/web-api--source/events/retailerMobile/click/footerMwebDesktopGooglePlayBadge";
import { observer } from "mobx-react";
import React, { useState } from "react";
import styled from "styled-components";
import { AppStoreBadge } from "@faire/retailer-visitor-shared/icons/AppDownloadBadge/AppStoreBadge";
import { GooglePlayBadge } from "@faire/retailer-visitor-shared/icons/AppDownloadBadge/GooglePlayBadge";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { AppDownloadModal } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/AppDownloadModal";
import { LoggedOutAppDownloadModal } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/LoggedOutAppDownloadModal";
import { getAppsFlyerOrStoreLinks, getStoreLinkUrl } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/utils";
export var AppModalType;
(function(AppModalType) {
    AppModalType["APPSTORE"] = "APPSTORE";
    AppModalType["GOOGLEPLAY"] = "GOOGLEPLAY";
})(AppModalType || (AppModalType = {}));
var AppDownloadBase = function(param) {
    var eventPrefix = param.eventPrefix, noModal = param.noModal, onClick = param.onClick, loggedOut = param.loggedOut;
    var _useState = _sliced_to_array(useState(), 2), appModalType = _useState[0], setAppModalType = _useState[1];
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var handleAppStoreClick = function() {
        onClick === null || onClick === void 0 ? void 0 : onClick();
        var appStoreLink;
        if (isLoggedInRetailer) {
            appStoreLink = getStoreLinkUrl().app_store_link;
            trackEvent("".concat(eventPrefix, "/app-store-badge-click"));
        } else {
            appStoreLink = getAppsFlyerOrStoreLinks().app_store_link;
            trackRetailerMobileFooterMwebDesktopappStoreBadgeClick();
        }
        if (noModal) {
            var _getWindow;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.open(appStoreLink);
        } else {
            setAppModalType(AppModalType.APPSTORE);
        }
    };
    var handleGooglePlayClick = function() {
        onClick === null || onClick === void 0 ? void 0 : onClick();
        var playStoreLink;
        if (isLoggedInRetailer) {
            playStoreLink = getStoreLinkUrl().play_store_link;
            trackEvent("".concat(eventPrefix, "/google-play-badge-click"));
        } else {
            playStoreLink = getAppsFlyerOrStoreLinks().play_store_link;
            trackRetailerMobileFooterMwebDesktopgooglePlayBadgeClick();
        }
        if (noModal) {
            var _getWindow;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.open(playStoreLink);
        } else {
            setAppModalType(AppModalType.GOOGLEPLAY);
        }
    };
    var handleCloseLoggedOutAppModal = function() {
        if (appModalType === AppModalType.APPSTORE) {
            trackRetailerMobileFooterDesktopappModaliosDismissClick();
        } else {
            trackRetailerMobileFooterDesktopappModalandroidDismissClick();
        }
        setAppModalType(undefined);
    };
    var handleCloseAppModal = function() {
        setAppModalType(undefined);
    };
    return /*#__PURE__*/ _jsxs(Row, {
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(StyledButton, {
                onClick: handleAppStoreClick,
                variant: "tertiary",
                children: /*#__PURE__*/ _jsx(AppStoreBadge, {})
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: "2x"
            }),
            /*#__PURE__*/ _jsx(StyledButton, {
                onClick: handleGooglePlayClick,
                variant: "tertiary",
                children: /*#__PURE__*/ _jsx(GooglePlayBadge, {})
            }),
            appModalType ? /*#__PURE__*/ _jsx(_Fragment, {
                children: loggedOut ? /*#__PURE__*/ _jsx(LoggedOutAppDownloadModal, {
                    appModalType: appModalType,
                    onClose: handleCloseLoggedOutAppModal
                }) : /*#__PURE__*/ _jsx(AppDownloadModal, {
                    eventPrefix: eventPrefix,
                    appModalType: appModalType,
                    onClose: handleCloseAppModal
                })
            }) : null
        ]
    });
};
export var AppDownload = observer(AppDownloadBase);
var StyledButton = styled(Button).withConfig({
    componentId: "sc-c0d21444-0"
})([
    "position:static;"
]);
